export const TASK_UPDATE = 'TASK_UPDATE';
export const TASK_LIST_UPDATE = 'TASK_LIST_UPDATE';
export const LOAD_TASKS = 'LOAD_TASKS';
export const ADD_TASK = 'ADD_TASK';
